import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-4 col-xxxl-3 mb-25" }
const _hoisted_3 = { class: "card border-0 rounded-0 bg-white letter-spacing chat-sidebar" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "chat-users-list mt-0" }
const _hoisted_6 = {
  key: 0,
  class: "p-25"
}
const _hoisted_7 = { class: "box" }
const _hoisted_8 = { class: "d-inline-block rounded-circle text-center text-primary fw-bold" }
const _hoisted_9 = ["id", "onClick"]
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "d-block text-black fs-md-15 fs-lg-16 fw-medium ms-12" }
const _hoisted_12 = { class: "col-lg-8 col-xxxl-9 mb-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createCommentVNode(" <form class=\"search-box position-relative\">\n            <input\n              type=\"text\"\n              class=\"form-control shadow-none text-black rounded-0 border-0\"\n              placeholder=\"Search message\"\n            />\n            <button\n              type=\"submit\"\n              class=\"bg-transparent text-primary transition p-0 border-0\"\n            >\n              <i class=\"flaticon-search-interface-symbol\"></i>\n            </button>\n          </form> "),
          _createCommentVNode(" <div class=\"chat-tabs\">\n            <router-link\n              to=\"/chat\"\n              class=\"text-decoration-none fw-medium transition text-center d-block\"\n            >\n              Private\n            </router-link>\n            <router-link\n              to=\"/chat-group\"\n              class=\"text-decoration-none fw-medium transition text-center d-block\"\n            >\n              Group\n            </router-link>\n            <router-link\n              to=\"/chat-contact\"\n              class=\"active text-decoration-none fw-medium transition text-center d-block\"\n            >\n              Contact\n            </router-link>\n          </div> "),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.patients === undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patient_groups, (values, key) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(key), 1 /* TEXT */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values, (patient) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["single-user-item pt-15 pb-15 position-relative", {'active': patient.id === _ctx.patient_id}]),
                    key: patient.id,
                    id: patient.id,
                    onClick: ($event: any) => (_ctx.select(patient))
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createCommentVNode(" <img src=\"@/assets/images/user/user4.jpg\" width=\"30\" height=\"30\" class=\"rounded-circle\" alt=\"user\" /> "),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(patient.lastname) + " " + _toDisplayString(patient.firstname), 1 /* TEXT */)
                    ])
                  ], 10 /* CLASS, PROPS */, _hoisted_9))
                }), 128 /* KEYED_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_router_view),
      _createCommentVNode(" <MessagesBody :patient=\"selected_patient\" /> ")
    ])
  ]))
}